import { render } from "./TermsTemplate1.vue?vue&type=template&id=5582700e&scoped=true"
import script from "./TermsTemplate1.vue?vue&type=script&lang=js"
export * from "./TermsTemplate1.vue?vue&type=script&lang=js"

import "./TermsTemplate1.vue?vue&type=style&index=0&id=5582700e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5582700e"]])

export default __exports__